class BackToTop extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.isAppear = false;
		this.threshold = 50;
		this.currentScrollTop = 0;
		this.onScrollHandler = this.onScroll.bind(this);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.onButtonClickHandler = this.onButtonClick.bind(this);
		this.querySelector('button').addEventListener('click', this.onButtonClickHandler);
	}

	onScroll() {
		const scrollTop = document.documentElement.scrollTop;
		//页面高度
		const pageHeight = document.body.scrollHeight - window.innerHeight;
		//滚动进度
		const scrollProgress = scrollTop / pageHeight;
		// this.querySelector('.backtoTop_container').style.height = `${scrollProgress*100 }%`
		if (scrollTop > this.threshold && scrollTop < this.currentScrollTop) {
			if (!this.isAppear) {
				this.appear();
			}
		} else if (scrollTop > this.threshold && scrollTop > this.currentScrollTop) {
			//go top一直显示 不要可注释
			if (!this.isAppear) {
				this.appear();
			}
		}
		else {
			if (this.isAppear) {
				this.hide();
			}
		}
		this.currentScrollTop = scrollTop;
	}

	onButtonClick(event) {
		window.isBackToTop = true;
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	appear() {
		///open show
		this.classList.add('open');
		this.isAppear = true;
	}

	hide() {
		this.classList.remove('open');
		this.isAppear = false;
	}
}

customElements.define('back-to-top', BackToTop);